import { Box, Button, Stack } from '@mui/material';
import dayjs from 'dayjs';

const CustomActionBarDatePicker = ({ onChange, value, setOpen }) => {
    return (
        <Box sx={{ px: 2, pt: 1.5, pb: 1 }}>
            <Stack direction="row" spacing={1} justifyContent="flex-end">
                <Button
                    size="small"
                    onClick={() => {
                        onChange(null);
                        setOpen?.(false);
                    }}
                >
                    Limpiar
                </Button>
                <Button
                    size="small"
                    onClick={() => {
                        onChange(dayjs());
                        setOpen?.(false);
                    }}
                >
                    Hoy
                </Button>
            </Stack>
        </Box>
    );
};

export default CustomActionBarDatePicker;